export default __webpack_public_path__ + "static/media/icon-flag-germany.b09a8f75.svg";